export const SERVICE_CONFIG = 'ServiceConfig'
export const WEBSITE_CONFIG = 'WebsiteConfig'
export const ADMIN_ROLE = 'admin'
export const RESTAURANT_ROLE = 'restaurant'

export const DYNAMIC_SECTIONS_POSITIONS = 'dynamicSectionsPositions'
export const DYNAMIC_SECTION_CONTENTS = 'dynamicSectionContents'
export const STATUS = 'status'
export const FOOTER_SEO_AREA = 'footerSeoArea'
export const TOP_BANNER_NEWS = 'topBannerNews'
export const THEME = 'theme'
export const ORDER_APP_NEWS = 'orderAppNews'
export const ORDER_APP_NEWS_TITLE_MAX = 27
export const ORDER_APP_NEWS_DESCRIPTION_MAX = 127

export const WEBP_DOT_EXTENSION = '.webp'

export const STAGING = 'staging'
export const IMG = 'img'
export const PHOTOS = 'photos'
export const STAGE_DEFAULT_IMAGE_BASE_URL = 'https://static.whatfood.uk/images/cms/staging/'

export const STAGE_IMAGES = [
    'https://static.whatfood.uk/images/cms/staging/1.webp',
    'https://static.whatfood.uk/images/cms/staging/2.webp',
    'https://static.whatfood.uk/images/cms/staging/3.webp',
    'https://static.whatfood.uk/images/cms/staging/4.webp',
    'https://static.whatfood.uk/images/cms/staging/5.webp',
    'https://static.whatfood.uk/images/cms/staging/6.webp',
    'https://static.whatfood.uk/images/cms/staging/7.webp',
    'https://static.whatfood.uk/images/cms/staging/8.webp',
    'https://static.whatfood.uk/images/cms/staging/9.webp',
    'https://static.whatfood.uk/images/cms/staging/20.webp',
    'https://static.whatfood.uk/images/cms/staging/21.webp',
    'https://static.whatfood.uk/images/cms/staging/22.webp',
    'https://static.whatfood.uk/images/cms/staging/23.webp',
    'https://static.whatfood.uk/images/cms/staging/40.webp',
    'https://static.whatfood.uk/images/cms/staging/41.webp',
    'https://static.whatfood.uk/images/cms/staging/42.webp',
    'https://static.whatfood.uk/images/cms/staging/43.webp',
    'https://static.whatfood.uk/images/cms/staging/44.webp'
]
